import { useStaticQuery, graphql } from "gatsby"

export const useFeaturedServicesQuery = () => {
    const { wpPage } = useStaticQuery(
        graphql`
        query FeaturedServicesQuery {
            wpPage(title: {eq: "Home"}) {
              featuredServices {
                featuredServicesHeading
                featuredServicesSubheading
                featuredServicesContent
                featuredServicesServices {
                  featuredServicesServicesIcon {
                    localFile {
                      childSvg {
                        content {
                          data
                        }
                      }
                    }
                  }
                  featuredServicesServicesLabel
                  featuredServicesServicesImage {
                    localFile {
                      childImageSharp {
                        gatsbyImageData
                      }
                    }
                  }
                  featuredServicesServicesImageAltText
                  featuredServicesServicesContent
                }
                featuredServicesBottomImage {
                  localFile {
                    childImageSharp {
                      gatsbyImageData
                    }
                  }
                }
                featuredServicesBottomImageAltText
              }
            }
          }
        `)
return wpPage.featuredServices
}